import Controller from "./directionMap.controller";
import template from "./directionMap.html";

const directionMap = {
  template,
  controller: Controller,
  bindings: {
    polygon1: "<",
    polygon2: "<",
    stations: "<",
    softStations: "<",
    hotLocations: "<",
    mode: "@",
    updateStationsEvent: "=",
    updateDemandEvent: "=",
    editStationEvent: "=",
    toggleOptimizationEvent: "=",
    toggleCreateModeEvent: "=",
    polyline: "<",
  },
};

export default directionMap;



// WEBPACK FOOTER //
// ./src/components/directionMap/directionMap.component.js